import tealium from './tealium';
import * as livePerson from './connector/live_person';
import * as liveTex from './connector/live_tex';
import * as perlgem from './connector/perlgem';
import * as scrollTracker from './connector/scroll_tracker';
import * as teester from './connector/teester';

(function (site) {
  document.addEventListener('DOMContentLoaded', async function () {
    // load all third party handlers - TODO: this should be handled via flags so only required ones are loaded
    perlgem.init();
    livePerson.init();
    liveTex.init();
    teester.init();

    window.addEventListener('track:ready', () => {
      // TODO: track this down and hopefully remove / migrate
      site.elcEvents.dispatch('tealium:displayWelcomeLoyaltyTag');
      if (tealium?.dataLayer?.data?.enable_scroll_tracking) {
        scrollTracker.init();
      }
    });
  });
})(window.site || {});
